export default __webpack_public_path__ + "7b66a47d57519436b6ee6a7ee558df40.svg";